import { Route, Routes, useLocation } from 'react-router-dom';
import { Dashboard, Profile, TemplateList } from '../pages/admin'
import ResetPassword from '../pages/admin/ResetPassword';
import { useSelector } from 'react-redux';
import { TemplateProvider } from '../pages/template-builder/context/TemplateContext';
import CasesPage from '../pages/cases/page';
import CaseDetailPage from '../pages/cases/[id]/page';
import DemandStudioPage from '../pages/demand-studio/[id]/page';
import LifecareStudioPage from '../pages/lifecare-studio/[id]/page';
import PreliminaryLifecarePlanPage from '../pages/preliminary-lifecare-plan/[id]/page';
import PreliminaryLifecarePlanRequestPage from '../pages/preliminary-lifecare-plan/certified-plan/[id]/page';
import FinalizeLifecareSummaryWrapper from '../components/FinalizeLifecareSummaryWrapper';
import AddCaseForm from '../components/AddCaseForm';
import AdminUserPage from '../pages/admin/users/pages';
import EasyModeCasePage from '../pages/easy-mode/[id]/page';
import DiscoveryPage from '../pages/discovery/page';
import DiscoveryOverviewPage from '../pages/discovery/discovery-overview/page';
import DiscoveryImportCasePage from '../pages/discovery/discovery-import/page';
import DiscoveryPreferencePage from '../pages/discovery/preference/page';
import Constants from '../Constants';

const Home = () => {
    const { isAdmin = false } = useSelector((state) => state.users || {});
    const location = useLocation();
    return <Routes>
        <Route path="dashboard" element={<Dashboard />} />

        <Route path="cases" element={<CasesPage />} />
        
        {!Constants.isDiscoveryHidden && <Route path="discovery">
            <Route index element={<DiscoveryPage />} />
            <Route path="overview/:caseId" element={<DiscoveryOverviewPage />} />
            <Route path="import" element={<DiscoveryImportCasePage />} />
            <Route path="preference" element={<DiscoveryPreferencePage />} />
        </Route>}
        
        <Route path="case/summary/:caseId" element={<CaseDetailPage />} />
        <Route path="case/:caseId/demand-studio" element={<DemandStudioPage />} />
        <Route path="case/:caseId/lifecare-studio" element={<LifecareStudioPage />} />
        <Route path="case/:caseId/preliminary-lifecare-plan" element={<PreliminaryLifecarePlanPage />} />
        <Route path="case/preliminary-lifecare-plan/certified-plan/:caseId" element={<PreliminaryLifecarePlanRequestPage />} />
        <Route path="case/finalize/:caseId" element={<FinalizeLifecareSummaryWrapper />} />
        <Route path="case/edit/:caseId" element={<AddCaseForm key={location.key} />} />
        <Route path="case/easy/:caseId" element={<EasyModeCasePage />} />
        <Route path="profile" element={<Profile />} />
        <Route path="forgot-password" element={<ResetPassword />} />
        {isAdmin && <Route path="template-builder" element={
            <TemplateProvider>
                <TemplateList />
            </TemplateProvider>
        } />}
        {isAdmin && <Route path="users" element={<AdminUserPage />} />}
    </Routes>
}

export default Home;